module.exports = __webpack_public_path__ + "static/media/carrocompra_white.bbe0b156.svg";